import * as React from 'react';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function MercadappDialog({ open, setOpen, title, message, buttons = [], loadingButtons = [] }) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {buttons.map((button, key) => (
            <Button key={key} color={button.color} onClick={button.action} variant={"contained"}>{button.text}</Button>
          ))}
          {loadingButtons.map((button, key) => (
            <LoadingButton
              key={key}
              loading={button.loading}
              color={button.color}
              onClick={button.action}
              variant={"contained"}
            >
              {button.text}
            </LoadingButton>
          ))}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default MercadappDialog